import React from 'react'
import { formatPercentage } from '../../../packages/utils/numberFormatters'
import { useTranslation } from 'react-i18next'

export const ColoredPercentage = ({ value }: { value: number | null }) => {
    const { i18n } = useTranslation()
    if (value === null) return '-'

    const color = value < 0 ? 'rgba(255, 0, 0, 0.85)' : 'rgba(0, 128, 0, 0.85)'

    return <div style={{ color }}>{formatPercentage(value, { signDisplay: 'exceptZero', locale: i18n.language })}</div>
}
